<template>
  <div>
    <div class="pt-4">
      <label class="font-18 d-block font-weight-bold">
        <i class="fas fa-info-circle color-orange mr-1" />
        Información de Cita Coordinada
      </label>
    </div>
    <div class="bg-light rounded py-2 px-3">
      <div class="row mt-3">
        <div class="col-12 col-md-2">
          <span class="data-title d-block">Tipo de Evaluación:</span>
          <span class="font-weight-normal">
            {{ data.evaluationName | empty }}
          </span>
        </div>
        <div class="col-12 col-md-2">
          <span class="data-title d-block">Disciplina:</span>
          <span class="font-weight-normal">
            {{ data.disciplineName | empty }}
          </span>
        </div>
        <div class="col-12 col-md-3">
          <span class="data-title d-block">Proveedor:</span>
          <span class="font-weight-normal">
            {{ data.providerName | empty }}
          </span>
        </div>
        <div class="col-12 col-md-3">
          <span class="data-title d-block">Especialista:</span>
          <span class="font-weight-normal">
            {{ data.specialistName | empty }}
          </span>
        </div>
        <div class="col-12 col-md-2">
          <span class="data-title d-block">Télefono de Contacto:</span>
          <span class="font-weight-normal">
            {{ data.providerPhoneNumber | phone }}
          </span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-2">
          <span class="data-title d-block">Número de cita:</span>
          <span class="font-weight-normal">
            {{ appointmentValue | appointment }}
          </span>
        </div>
        <div class="col-12 col-md-2">
          <span class="data-title d-block">Fecha de la Cita:</span>
          <span class="font-weight-normal">
            {{ data.appointmentDateTime | date('DD/MM/YYYY') }}
          </span>
        </div>
        <div class="col-12 col-md-3">
          <span class="data-title d-block">Hora de la Cita:</span>
          <span class="font-weight-normal">
            {{ data.appointmentDateTime | date('hh:mm a') }}
          </span>
        </div>
        <div class="col-12 col-md-3">
          <span class="data-title d-block">Dirección:</span>
          <span class="font-weight-normal">
            {{ data.providerAddress | empty }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppointmentView',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    appointmentValue() {
      return this.data?.appointmentId?.toString() || '';
    },
  },
};
</script>

<style></style>
